<template>
  <div class="legend">
    <div class="legend-content" v-if="showLegend && categories.length">
      <div class="legend-close">
        <a @click.stop.prevent="showLegend = false">
          <i class="icon-notice_close"></i>
        </a>
      </div>
      <ul class="legend-items">
        <li>
          <div class="legend-circle" style="background: #757575">
            <span class="inner">n</span>
          </div>
          <div class="legend-text">
            <translate>Regroupement de n mouvements</translate>
          </div>
        </li>
        <li :key="index" v-for="(item, index) in categories" :class="{ odd: !(index % 2) }">
          <div class="legend-circle bordered" :style="{ 'border-color': item.color }"></div>
          <div class="legend-text">{{ item.value }}</div>
        </li>
      </ul>
    </div>
    <button class="custom-control-div" @click="openLegend">
      <translate>Légende</translate>
    </button>
  </div>
</template>
<script>
import { movementParameters } from 'config';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LegendControl',
  mounted() {
    this.$parent.$mapPromise.then((m) => {
      m.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(this.$el);
    });
  },
  methods: {
    ...mapActions('aggregations', ['fetchTerms']),
    async openLegend() {
      await this.fetchTerms('category');
      this.showLegend = true;
    },
  },
  computed: {
    ...mapGetters('aggregations', ['terms']),
    categories() {
      const aggregationCatgory = this.terms.map((t) => t.key);
      return Object.values(this.configCategories).filter((k) => {
        return aggregationCatgory.includes(k.value);
      });
    },
  },
  data() {
    return {
      showLegend: false,
      configCategories: movementParameters.categories,
    };
  },
};
</script>
<style lang="less" scoped>
.legend {
  box-shadow: none;
  text-align: left;
  margin-right: 55px;
  margin-bottom: -100px;

  .custom-control-div {
    background-color: #fff;
    border: 2px solid #fff;
    padding: 2px 5px;
    z-index: 99;
    position: relative;
    box-shadow: 0px 2px 1.72px 0.28px rgba(0, 0, 0, 0.4);
  }

  .legend-content {
    cursor: default;
    position: absolute;
    right: 45px;
    bottom: 0;
    z-index: 98;
    box-shadow: none;
    .legend-close {
      position: relative;
      display: flex;
      justify-content: flex-end;
      a {
        i {
          color: black;
        }
      }
    }
  }
}

.legend-items {
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  margin: 0;
  padding: 0;

  li {
    white-space: nowrap;
    display: flex;
    align-items: center;
    line-height: 40px;
    background-color: #fff;
    width: 100%;
    border-bottom: 1px solid @artwork-sidebar-details-border;
    &.odd {
      background-color: #f6f6f6;
    }

    .legend-circle {
      background: white;
      color: white;
      border-radius: 50%;
      height: 15px;
      width: 15px;
      position: relative;
      margin: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      .inner {
        line-height: 1;
      }

      &.bordered {
        border-width: 4px;
        border-style: solid;
      }
    }
    .legend-text {
      font-size: 12px;
      padding-right: 80px;
    }
  }
}
</style>
